<form class="form-horizontal" #form="ngForm" (ngSubmit)="onSubmit()">
  <div class="form-group">
    <label class="control-label col-sm-3">
      {{ 'Update Date' | translate }}:
    </label>
    <div class="col-sm-9">
      <app-select-date 
      (seteditday)="onSelectday($event)">
      </app-select-date>
    </div>
    <label class="control-label col-sm-3">
      {{ 'Update Time' | translate }}:
    </label>
    <div class="col-sm-9" style="margin-top: 10px">
      <input 
      type="time" 
      (change)="onSelectTime()" 
      required
      name="arrivalTime"
      [(ngModel)]="arrivalTime">
    </div>
  </div>
  <div class="form-group">
    <div class="col-sm-offset-3 col-sm-9">
      <button type="submit" class="btn btn-primary btn-sm btn-right"  [disabled]="form.form.invalid || form.form.pending ">
        <span>
          {{ 'Update' | translate }}
        </span>
      </button>
    </div>
  </div>
</form>
